export const EVENT = {
  name: "Aesthetic Symposium 2026",
  subtitle: "Botox · Fillers · Threads",
  tagline: "Practical Injectables. Clinical Judgement. Better Patient Outcomes.",
  date: "5 July 2026",
  time: "09:00 – 17:00",
  venue: "Le Méridien Amritsar",
  organizer: "An educational initiative by Eden Skin Clinic",
  website: "aestheticSymposium.in",
  mapsUrl: "https://share.google/hyMwG1mIWk3wpNMw8",
  instagram: "https://instagram.com/aesthetic.symposium",
  instagramHandle: "@aesthetic.symposium",
  phone: "+91 77107 79393",
  phoneRaw: "+917710779393",
  secretariat: {
    name: "Eden Skin Clinic",
    address: "Ranjit Avenue, D Block, Amritsar",
    mapsUrl:
      "https://www.google.com/maps/search/?api=1&query=Eden+Skin+Clinic+Ranjit+Avenue+D+Block+Amritsar",
  },
};

export const THEMES = [
  {
    n: "01",
    title: "Foundations",
    body: "Build a strong understanding of injection anatomy, safety, and core scientific principles.",
  },
  {
    n: "02",
    title: "Techniques",
    body: "Practical, repeatable approaches for Botulinum Toxin, Dermal Fillers, and Threads.",
  },
  {
    n: "03",
    title: "Complication Management",
    body: "What can go wrong, why it happens, prevention, and confident management.",
  },
  {
    n: "04",
    title: "Live Video Demonstrations",
    body: "See expert techniques in action through live video for Botox, Fillers, and Threads.",
  },
  {
    n: "05",
    title: "Panel Discussion",
    body: "Real-world aesthetic cases discussed with faculty across differing clinical viewpoints.",
  },
];

export const SESSIONS = [
  {
    kind: "session",
    time: "08:30 – 09:00",
    title: "Registration",
    duration: "30 min",
    speakers: [],
    items: ["Delegate check-in & welcome refreshments"],
  },
  {
    kind: "session",
    time: "09:00 – 09:15",
    title: "Hyperpigmentation Management",
    duration: "15 min",
    speakers: ["Dr. Ameesha Mahajan"],
    items: ["Hyperpigmentation Management — Dr. Ameesha Mahajan"],
  },
  {
    kind: "session",
    time: "09:15 – 09:30",
    title: "Topical Pirfenidone in the Management of Scars",
    duration: "15 min",
    speakers: ["Dr. Vikas Kakkar"],
    items: ["Topical Pirfenidone in the Management of Scars — Dr. Vikas Kakkar"],
  },
  {
    kind: "session",
    time: "09:30 – 10:05",
    title: "Session 1 · Injection Anatomy",
    duration: "35 min",
    speakers: ["Dr. Neha Sachde", "Dr. Sukhbir Singh"],
    items: [
      "Injection Anatomy: Neurotoxin — Dr. Neha Sachde",
      "Injection Anatomy: Dermal Filler — Dr. Sukhbir Singh",
      "Audience Q&A",
    ],
  },
  {
    kind: "session",
    time: "10:05 – 10:50",
    title: "Session 2 · Injection Principles & Techniques",
    duration: "45 min",
    speakers: ["Dr. Chirranjiv Chabraa", "Dr. Kuldeep Singh"],
    items: [
      "Principle & Technique: Neurotoxin — Dr. Chirranjiv Chabraa",
      "Principle & Technique: Dermal Filler — Dr. Kuldeep Singh",
      "Audience Q&A",
    ],
  },
  {
    kind: "ceremony",
    time: "10:50 – 11:05",
    title: "Inauguration",
    duration: "15 min",
    speakers: [],
    items: ["Formal inauguration of Aesthetic Symposium 2026"],
  },
  {
    kind: "session",
    time: "11:05 – 11:50",
    title: "Session 3 · Complications & Management",
    duration: "45 min",
    speakers: ["Dr. Chirranjiv Chabraa", "Dr. Kuldeep Singh"],
    items: [
      "Neuromodulator Complications — Dr. Chirranjiv Chabraa",
      "Dermal Filler Complications — Dr. Kuldeep Singh",
      "Audience Q&A",
    ],
  },
  {
    kind: "break",
    time: "11:50 – 12:10",
    title: "Tea Break",
    duration: "20 min",
    speakers: [],
    items: [],
  },
  {
    kind: "session",
    time: "12:10 – 13:20",
    title: "Session 4 · Live Demo",
    duration: "70 min",
    speakers: ["Dr. Chirranjiv Chabraa", "Dr. Kuldeep Singh"],
    items: [
      "Neuromodulator Live Demo — Dr. Chirranjiv Chabraa",
      "Dermal Filler Live Demo: Mid-face & Under Eye — Dr. Kuldeep Singh",
      "Audience Q&A",
    ],
  },
  {
    kind: "break",
    time: "13:20 – 14:10",
    title: "Lunch",
    duration: "50 min",
    speakers: [],
    items: [],
  },
  {
    kind: "session",
    time: "14:10 – 14:55",
    title: "Session 5 · Threads",
    duration: "45 min",
    speakers: ["Dr. Chetna Ramchandani", "Dr. Sukhbir Singh"],
    items: [
      "Anatomy & Technique — Dr. Chetna Ramchandani",
      "Complications of Threads — Dr. Sukhbir Singh",
      "Audience Q&A",
    ],
  },
  {
    kind: "session",
    time: "14:55 – 15:35",
    title: "Session 6 · Live Demo",
    duration: "40 min",
    speakers: ["Dr. Sukhbir Singh"],
    items: ["Cog Threads Live Demo — Dr. Sukhbir Singh"],
  },
  {
    kind: "break",
    time: "15:35 – 15:50",
    title: "Tea Break",
    duration: "15 min",
    speakers: [],
    items: [],
  },
  {
    kind: "session",
    time: "15:50 – 16:50",
    title: "Session 7 · Panel Discussion",
    duration: "60 min",
    speakers: ["Dr. Sunil Gaba", "Dr. Ameesha Mahajan"],
    panelists: [
      "Dr. Kuldeep Singh",
      "Dr. Chirranjiv Chabraa",
      "Dr. Sukhbir Singh",
      "Dr. Chetna Ramchandani",
      "Dr. Neha Sachde",
    ],
    items: ["Open clinical discussion across Botox, Fillers and Threads"],
  },
  {
    kind: "ceremony",
    time: "16:50 – 17:00",
    title: "Vote of Thanks",
    duration: "10 min",
    speakers: ["Dr. Ameesha Mahajan"],
    items: ["Closing remarks — Dr. Ameesha Mahajan"],
  },
];

// Faculty / committee photographs hosted as public assets.
const IMG_KULDEEP =
  "https://customer-assets.emergentagent.com/job_elated-wilson-7/artifacts/dqf79zsd_b83f714d-1168-4493-9519-9ffefa286213.jpeg";
const IMG_SUKHBIR =
  "https://customer-assets.emergentagent.com/job_elated-wilson-7/artifacts/hcd046xz_2a657c48-c9cc-49d3-8b40-48fed3747f6d.jpeg";
const IMG_CHIRANJIV =
  "https://customer-assets.emergentagent.com/job_elated-wilson-7/artifacts/chi2qn4b_c6d0eda2-e901-4f35-a4f2-5acc5b4efacd.jpeg";
const IMG_RAVI =
  "https://customer-assets.emergentagent.com/job_elated-wilson-7/artifacts/pampmfww_e9e72cec-faf0-4a3b-8352-4c440a3a9a51.jpeg";
const IMG_SUNIL =
  "https://customer-assets.emergentagent.com/job_elated-wilson-7/artifacts/91xmgp92_50d19fdd-e465-4dbd-97f3-3e40cd10714c.jpeg";
const IMG_AMEESHA =
  "https://customer-assets.emergentagent.com/job_elated-wilson-7/artifacts/u8ydzskp_941c2ba1-8d13-4585-9e47-0d42c1ee6cdf.jpeg";
const IMG_CHETNA =
  "https://customer-assets.emergentagent.com/job_elated-wilson-7/artifacts/czcg8a2g_IMG_4273.jpeg";
const IMG_NEHA =
  "https://customer-assets.emergentagent.com/job_elated-wilson-7/artifacts/5p8i9vut_IMG_4274.jpeg";

export const FACULTY = [
  {
    name: "Dr. Kuldeep Singh",
    role: "Faculty · Dermal Fillers · Scientific Chairperson",
    initials: "KS",
    image: IMG_KULDEEP,
    imagePos: "50% 22%",
  },
  {
    name: "Dr. Chirranjiv Chabraa",
    role: "Faculty · Neurotoxin Techniques & Complications",
    initials: "CC",
    image: IMG_CHIRANJIV,
    imagePos: "50% 25%",
  },
  {
    name: "Dr. Sukhbir Singh",
    role: "Faculty · Threads & Filler Anatomy",
    initials: "SS",
    image: IMG_SUKHBIR,
    imagePos: "50% 28%",
  },
  {
    name: "Dr. Chetna Ramchandani",
    role: "Faculty · Threads Anatomy & Technique",
    initials: "CR",
    image: IMG_CHETNA,
    imagePos: "50% 28%",
  },
  {
    name: "Dr. Neha Sachde",
    role: "Faculty · Neurotoxin Anatomy",
    initials: "NS",
    image: IMG_NEHA,
    imagePos: "50% 35%",
  },
];

export const COMMITTEE = [
  { name: "Dr. Ravi Mahajan", role: "Organising Chairperson", initials: "RM", image: IMG_RAVI, imagePos: "50% 25%" },
  { name: "Dr. Kuldeep Singh", role: "Scientific Chairperson", initials: "KS", image: IMG_KULDEEP, imagePos: "50% 22%" },
  { name: "Dr. Sunil Gaba", role: "Scientific Co-chairperson", initials: "SG", image: IMG_SUNIL, imagePos: "50% 30%" },
  { name: "Dr. Ameesha Mahajan", role: "Organising Secretary", initials: "AM", image: IMG_AMEESHA, imagePos: "50% 38%" },
];

export const TAKEAWAYS = [
  "Clearer understanding of injectable anatomy",
  "Practical Botox, filler, and thread techniques",
  "Real-world insights from experienced injectors",
  "Better understanding of complications and management",
  "Confidence to inject with knowledge, not fear",
  "A more individualized approach to treatment planning",
  "Practical pearls that can be implemented in clinic",
];

export const FAQS = [
  {
    q: "Who can attend Aesthetic Symposium 2026?",
    a: "The symposium is intended for Dermatologists and Plastic Surgeons interested in Botox, Fillers, and Threads.",
  },
  {
    q: "Will there be live demonstrations?",
    a: "Yes. The program includes live video demonstrations of Botulinum toxin, dermal fillers, and cog threads.",
  },
  {
    q: "Is this suitable for beginners?",
    a: "Yes. The symposium is designed for both budding and experienced Dermatologists and Plastic Surgeons. It covers foundations as well as advanced practical insights.",
  },
  {
    q: "Will complication management be discussed?",
    a: "Yes. Dedicated sessions will cover neuromodulator and dermal filler complications along with practical management insights.",
  },
  {
    q: "Are PMC points available?",
    a: 'Yes. <span style="color:#B91C1C;font-weight:600;">4 CME points have been accredited by PMC</span> for this symposium.',
  },
  {
    q: "Is the schedule final?",
    a: "The program schedule is subject to change.",
  },
  {
    q: "How do I register?",
    a: "Registration is complimentary but mandatory. Please complete the registration form on this page — our team will confirm via WhatsApp and email.",
  },
];

export const INTEREST_OPTIONS = [
  "Botox",
  "Fillers",
  "Threads",
  "Complication Management",
  "All of the above",
];

export const QUALIFICATION_OPTIONS = [
  "MD (Skin & VD) / DNB (Skin & VD) / DVL / DVD",
  "MCh / DNB Plastic Surgery",
];

export const SPECIALTY_OPTIONS = ["Dermatology", "Plastic Surgery"];

// People featured in the Videos section (organising committee first, then faculty).
// Each entry can optionally include a `videoUrl` (YouTube / Vimeo / direct MP4)
// or an `instagramUrl` (Instagram Reel / post). When neither is set the card
// displays a "Coming soon" state.
export const VIDEOS = [
  // Organising Committee
  { name: "Dr. Ravi Mahajan", role: "Organising Chairperson", initials: "RM", image: IMG_RAVI, imagePos: "50% 25%", group: "Committee", videoUrl: null, instagramUrl: "https://www.instagram.com/reel/DZ_8ejmzrj5/" },
  { name: "Dr. Kuldeep Singh", role: "Scientific Chairperson", initials: "KS", image: IMG_KULDEEP, imagePos: "50% 22%", group: "Committee", videoUrl: null, instagramUrl: "https://www.instagram.com/reel/DaFQzurzM1K/" },
  { name: "Dr. Sunil Gaba", role: "Scientific Co-chairperson", initials: "SG", image: IMG_SUNIL, imagePos: "50% 30%", group: "Committee", videoUrl: null, instagramUrl: null },
  { name: "Dr. Ameesha Mahajan", role: "Organising Secretary", initials: "AM", image: IMG_AMEESHA, imagePos: "50% 38%", group: "Committee", videoUrl: null, instagramUrl: "https://www.instagram.com/reel/DZuvQdqTmkg/" },
  // Faculty
  { name: "Dr. Chirranjiv Chabraa", role: "Neurotoxin Techniques", initials: "CC", image: IMG_CHIRANJIV, imagePos: "50% 25%", group: "Faculty", videoUrl: null, instagramUrl: "https://www.instagram.com/reel/DaCgOO9zrst/" },
  { name: "Dr. Sukhbir Singh", role: "Threads & Filler Anatomy", initials: "SS", image: IMG_SUKHBIR, imagePos: "50% 28%", group: "Faculty", videoUrl: null, instagramUrl: null },
  { name: "Dr. Chetna Ramchandani", role: "Threads Anatomy & Technique", initials: "CR", image: IMG_CHETNA, imagePos: "50% 28%", group: "Faculty", videoUrl: null, instagramUrl: "https://www.instagram.com/reel/DZzLYWazPaU/" },
  { name: "Dr. Neha Sachde", role: "Neurotoxin Anatomy", initials: "NS", image: IMG_NEHA, imagePos: "50% 35%", group: "Faculty", videoUrl: null, instagramUrl: "https://www.instagram.com/reel/DZrgqzvzqpC/" },
];
